export const selectCompanyId = store => store.company.currentCompany?.company?.id;
export const selectCompany = store => store.company.currentCompany?.company;
export const selectCompanyIntegrationType = store => store.company.currentCompany?.company?.integrationType;
export const selectCompanyWithdrawalsPaginated = store => store.company.currentCompany?.withdrawalsPaginated;
export const selectInsights = store => store.company?.insights;
